module.exports = __webpack_public_path__ + "static/media/PopUP.00b4783f.png";